import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

// Thunk: fetch paginated messages with filters; caches per key
export const fetchMessagesPage = createAsyncThunk(
  'messages/fetchPage',
  async ({ page = 1, limit = 50, search = '', status = 'all', dateFrom = '', dateTo = '' }, { getState }) => {
    const token = localStorage.getItem('token');
    const params = { page, limit, search, status };
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;
    const { data } = await axios.get(`${API_URL}/api/admin/messages`, {
      headers: { Authorization: `Bearer ${token}` },
      params
    });
    return { key: JSON.stringify(params), data };
  }
);

const initialState = {
  // cache: key -> { messages, pagination }
  pagesByKey: {},
  loadingByKey: {},
  errorByKey: {}
};

const messagesSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    // optimistic updates could go here if needed
    invalidateAll(state) {
      state.pagesByKey = {};
      state.loadingByKey = {};
      state.errorByKey = {};
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMessagesPage.pending, (state, action) => {
        const key = JSON.stringify(action.meta.arg || {});
        state.loadingByKey[key] = true;
        state.errorByKey[key] = null;
      })
      .addCase(fetchMessagesPage.fulfilled, (state, action) => {
        const { key, data } = action.payload;
        state.loadingByKey[key] = false;
        state.pagesByKey[key] = data;
      })
      .addCase(fetchMessagesPage.rejected, (state, action) => {
        const key = JSON.stringify(action.meta.arg || {});
        state.loadingByKey[key] = false;
        state.errorByKey[key] = action.error?.message || 'Failed to fetch messages';
      });
  }
});

export const { invalidateAll } = messagesSlice.actions;
export default messagesSlice.reducer;

